import checkout from "./form";

const {
  formField: {
    name,
    description,
    startDate,
    endDate,
    priority,
    Status,
    projectId,
    ResponsibilityText,
    SolutionDescription,
  },
} = checkout;

const initialValues = {
  [name.name]: "",
  [description.name]: "",
  [startDate.name]: new Date().toISOString().slice(0, 10),
  [endDate.name]: new Date().toISOString().slice(0, 10),
  [priority.name]: 0,
  [Status.name]: 0,
  [projectId.name]: "",
  [ResponsibilityText.name]: "",
  [SolutionDescription.name]: "",
};

export default initialValues;
